import { supabase } from '../supabaseClient';

export type BetaEventCodeAutoSendSettings = {
  autoSendEnabled: boolean;
  updatedAt?: string;
};

const DEFAULT: BetaEventCodeAutoSendSettings = { autoSendEnabled: false };

function mapRow(row: Record<string, unknown> | null | undefined): BetaEventCodeAutoSendSettings {
  if (!row) return { ...DEFAULT };
  return {
    autoSendEnabled: Boolean(row.auto_send_enabled),
    updatedAt: typeof row.updated_at === 'string' ? row.updated_at : undefined,
  };
}

/** 관리자: 베타 코드 자동발송 설정 조회(DB 공통) */
export async function getBetaEventCodeAutoSendSettings(): Promise<BetaEventCodeAutoSendSettings> {
  const { data, error } = await supabase
    .from('platform_beta_event_code_settings')
    .select('auto_send_enabled, updated_at')
    .eq('id', 'default')
    .maybeSingle();
  if (error) throw error;
  return mapRow(data as Record<string, unknown> | null);
}

/** 관리자: 베타 코드 자동발송 ON/OFF 저장(모든 디바이스 공통) */
export async function setBetaEventCodeAutoSendEnabled(
  enabled: boolean,
): Promise<BetaEventCodeAutoSendSettings> {
  const { data, error } = await supabase
    .from('platform_beta_event_code_settings')
    .upsert(
      {
        id: 'default',
        auto_send_enabled: enabled,
        updated_at: new Date().toISOString(),
      },
      { onConflict: 'id' },
    )
    .select('auto_send_enabled, updated_at')
    .single();
  if (error) throw error;
  return mapRow(data as Record<string, unknown>);
}
